import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, identifier} from '@packages/systems/wfdl-Qualified';

import Meta from './Meta';
import Title from './Title';
import CustomCode from './CustomCode';
import Comment from './Comment';
import FacebookPixel from './FacebookPixel';
import GoogleAnalytics from './GoogleAnalytics';

import {
  TText,
  TList,
  TRecord,
  EElement,
  EText,
  ERecord,
  EList,
  EData,
  EFunction,
  TElement,
} from '@packages/systems/wfdl-ast';

const {PrivilegedPlugin} = Plugins;

const attributesDataType = TList(
  TRecord({
    name: TText,
    value: TText,
  })
);
const childrenSlotDataType = TList(TElement);
const attributesData = EData(['attributes']);
const childrenData = EData(['childrenSlot']);

const qualifiedBuiltinDOM = qualify(
  Plugins.name('Builtin'),
  Component.name('DOM')
);

const Script = Component.create({
  dataType: TRecord({
    attributes: attributesDataType,
    value: TText,
  }),
  defaultData: EFunction({
    param: identifier('context'),
    body: ERecord({
      attributes: EList([]),
      value: EText(''),
    }),
  }),
  render: EElement({
    id: 'Script',
    type: qualify(Plugins.name('Builtin'), Component.name('DangerousDOM')),
    data: ERecord({
      tag: EText('script'),
      value: EData(['value']),
      attributes: attributesData,
    }),
  }),
});

const Style = Component.create({
  dataType: TRecord({
    value: TText,
  }),
  defaultData: EFunction({
    param: identifier('context'),
    body: ERecord({
      value: EText(''),
    }),
  }),
  render: EElement({
    id: 'Style',
    type: qualify(Plugins.name('Builtin'), Component.name('DangerousDOM')),
    data: ERecord({
      tag: EText('style'),
      value: EData(['value']),
    }),
  }),
});

const Resource = Component.create({
  dataType: TRecord({
    attributes: attributesDataType,
  }),
  defaultData: EFunction({
    param: identifier('context'),
    body: ERecord({
      attributes: EList([]),
    }),
  }),
  render: EElement({
    id: 'Resource',
    type: qualifiedBuiltinDOM,
    data: ERecord({
      tag: EText('link'),
      children: EList([]),
      attributes: attributesData,
    }),
  }),
});

const Base = Component.create({
  dataType: TRecord({
    attributes: attributesDataType,
  }),
  defaultData: EFunction({
    param: identifier('context'),
    body: ERecord({
      attributes: EList([]),
    }),
  }),
  render: EElement({
    id: 'Base',
    type: qualifiedBuiltinDOM,
    data: ERecord({
      tag: EText('base'),
      children: EList([]),
      attributes: attributesData,
    }),
  }),
});

const Head = Component.create({
  dataType: TRecord({
    childrenSlot: childrenSlotDataType,
  }),
  defaultData: EFunction({
    param: identifier('context'),
    body: ERecord({
      childrenSlot: EList([]),
    }),
  }),
  render: EElement({
    id: 'Head',
    type: qualifiedBuiltinDOM,
    data: ERecord({
      tag: EText('head'),
      attributes: EList([]),
      children: childrenData,
    }),
  }),
});

const Document = Component.create({
  dataType: TRecord({
    attributes: attributesDataType,
    childrenSlot: childrenSlotDataType,
  }),
  defaultData: EFunction({
    param: identifier('context'),
    body: ERecord({
      attributes: EList([]),
      childrenSlot: EList([]),
    }),
  }),
  render: EElement({
    id: 'Document',
    type: qualifiedBuiltinDOM,
    data: ERecord({
      tag: EText('html'),
      attributes: attributesData,
      children: childrenData,
    }),
  }),
});

export const plugin = PrivilegedPlugin({
  components: {
    Head,
    Document,
    Style,
    Script,
    Base,
    Resource,
  },
  atoms: {
    Meta,
    Title,
    CustomCode,
    Comment,
    FacebookPixel,
    GoogleAnalytics,
  },
});
